import { useEffect, useState } from 'react';
import { fetchWrapper } from '@/lib/fetch-wrapper';
import { Box, useTheme, Typography, Alert } from '@mui/material';
import { Loader } from '../loader/loader';
import { formatCurrencyNoUnit } from '@/lib/formatters';
import { SvgVBars, CHART_H } from '@/components/ds/charts';

export default function Top10Costs(props: any) {
  const theme = useTheme();
  const [chartItems, setChartItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    fetchWrapper
      .get(props.url + (props.filters ? `?${props.filters}` : ''))
      .then((data) => {
        // Ensure data is an array
        const dataArray = Array.isArray(data) ? data : [];
        setChartItems(dataArray);
        setLoading(false);
      })
      .catch((error) => {
        console.error('There was an error!', error);
        setError(error);
        setLoading(false);
      });
  }, [props.url, props.filters]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">Error loading data.</Alert>
      </Box>
    );
  }

  const chartData =
    Array.isArray(chartItems) && chartItems.length > 0
      ? chartItems.map((item: any) => ({
          name: item?.name ?? 'Unknown',
          spending: item?.spending ?? 0,
        }))
      : [];

  // Default to theme primary (blue) for reporting, allow override for optimization (orange - index 1)
  const barColor = props.color || theme.palette.primary.main;

  if (chartData.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={400}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
          No data available
        </Typography>
      </Box>
    );
  }

  return (
    <SvgVBars
      data={chartData.map((item) => ({
        v: item.spending,
        l: item.name,
        c: barColor,
      }))}
      w={props.width}
      h={props.height ?? CHART_H}
      color={barColor}
      fmt={formatCurrencyNoUnit}
    />
  );
}
